import { OpenWorldPersistenceError, type OpenWorldPersistenceErrorCode } from '@/lib/openWorlds/persistence'

/** Errors shared by live canon acquisition in turn and note claims. */
export function openWorldCanonError(error: { message?: string }): OpenWorldPersistenceError | null {
  const messages: Record<string, [OpenWorldPersistenceErrorCode, string]> = {
    OW_SOURCE_REQUIRED: ['source_required', 'This legacy story has no source World. Enable Use World snapshot in its setup to continue.'],
    OW_SOURCE_UNAVAILABLE: ['source_unavailable', 'The live World is unavailable. Restore access or enable Use World snapshot in its setup.'],
    OW_SOURCE_UNPUBLISHED: ['source_unpublished', 'Publish the source World or enable Use World snapshot in the setup to continue.'],
    OW_SOURCE_INVALID: ['source_invalid', 'The published World exceeds Open Worlds limits or has invalid canon. Correct it or enable Use World snapshot in the setup.'],
    OW_RELOAD_REQUIRED: ['reload_required', 'Reload this page to use the current World snapshot settings.'],
  }
  const matched = messages[error.message ?? '']
  return matched ? new OpenWorldPersistenceError(matched[0], matched[1], { cause: error }) : null
}
